/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { OutreachCuraiRedirectContentActionTaken } from "./OutreachCuraiRedirectContentActionTaken";

export interface OutreachCuraiRedirectContent {
  subjective_override: string;
  action_taken?: OutreachCuraiRedirectContentActionTaken;
  archived?: boolean;
}
